"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineObject10 = void 0;
const iwork_order_search_entity_1 = require("./iwork-order-search-entity");
function parseInlineObject10(data) {
    if (data.work_order_filter !== null && typeof data.work_order_filter === 'object')
        data.work_order_filter = (0, iwork_order_search_entity_1.parseIWorkOrderSearchEntity)(data.work_order_filter);
    return data;
}
exports.parseInlineObject10 = parseInlineObject10;
